import {
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormControl,
} from '@angular/forms';
import { NgClass, DatePipe } from '@angular/common';
// Third Party
// Ag-Grid
import {
  GridOptions,
  GridApi,
  ColDef,
  IRowNode,
  ColumnState,
} from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { agGridDarkTheme } from 'src/app/shared/components/ag-grid/dark-theme';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import {
  Answers,
  DateFormats,
  FirearmTypes,
  ModalID,
  ModalType,
  Questions,
  StatusModalIndicator,
} from 'src/app/shared/models/constants';
import { format } from 'date-fns';
// Models
import {
  AddEditFirearmResponse,
  BoundBookEntry,
  EventEntry,
  Note,
} from 'src/app/shared/models/general';
import { Firearm } from 'src/app/shared/models/general';
// Services
import { SharedService } from 'src/app/shared/services/shared.service';
import { NotesColumnDef, EventLogsColumnDef } from './columnDefs';
import { formatEventValue } from '../../functions';

@Component({
  selector: 'app-firearm-info-dash',
  templateUrl: './firearm-info-dash.component.html',
  styleUrls: ['./firearm-info-dash.component.scss'],
  standalone: true,
  imports: [NgClass, DatePipe, AgGridAngular, CollapseModule, BsDropdownModule],
})
export class FirearmInfoDashComponent {
  add_edit_firearm_form: FormGroup;
  bound_book_entry: BoundBookEntry;
  selected_row: Firearm = new Firearm();
  firearm_types = FirearmTypes;
  firearm_information: string;

  duplicate_enabled_entry = true;
  duplicate_entry = true;
  notesIsCollapsed = true;
  historyIsCollapsed = true;

  noteData: Note[] = [];
  eventData: EventEntry[] = [];
  message = 'expanded';
  modified_by = this.sharedService.logged_in_user.username;
  modified_datetime: string;
  // Modals
  modalRef: BsModalRef;
  modalConfig = { animated: true };

  // ag-grid properties Grid
  gridApi!: GridApi;

  columnDefs: ColDef[] = NotesColumnDef;
  eventColumnDefs: ColDef[] = EventLogsColumnDef;
  defaultColDef = {
    // resizable: true,
    // minWidth: 50,
    // flex: 1
  };
  detailCellRendererParams: any;
  overlayLoadingTemplate;
  overlayNoRowsTemplate;
  gridOptions: GridOptions = {
    theme: agGridDarkTheme,
    headerHeight: 30,
    rowHeight: 25,
    suppressPaginationPanel: true,
  };
  theme = agGridDarkTheme;
  constructor(
    protected element: ElementRef,
    private modalService: BsModalService,
    private fb: FormBuilder,
    public sharedService: SharedService,
  ) {
    // Initializing Form
    this.add_edit_firearm_form = this.fb.group({
      firearm_upc: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
      firearm_type: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
      manufacture: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
      importer: new FormControl({ value: null, disabled: false }),
      model: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
      additional_markings: new FormControl({ value: null, disabled: false }),
      caliber_gauge: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
    });
    this.sharedService.firearm_to_edit$.subscribe(
      async (edited_firearm_entry) => {
        await this.sharedService.updateBoundBookEntry(edited_firearm_entry);
        this.createNoteTable();
        this.createEventTable();
      },
    );
    this.sharedService.yes_no_submit$.subscribe(async (response) => {
      if (
        response['answer'] === Answers.yes &&
        response['question'] === Questions.revert_disposition
      ) {
        // open a text modal for a event entry
        this.sharedService.closeModal(ModalID.firearm_info_dash);
        this.sharedService.openStatusSpinner('Reverting Disposition');
        await this.revertDisposition();
        this.sharedService.closeStatusSpinner();
      }
    });
  }
  ngOnInit(): void {
    this.createNoteTable();
    this.createEventTable();
    this.modified_datetime = this.findModifiedDateTime();
    console.warn(this.bound_book_entry);
    this.firearm_information =
      this.bound_book_entry.a_manufacture +
      ' - ' +
      this.bound_book_entry.a_model +
      ' - ' +
      this.bound_book_entry.a_caliber_gauge;
  }

  findModifiedDateTime() {
    const acquisition_date = new Date(this.bound_book_entry.a_date_acquired);
    const disposition_date = new Date(this.bound_book_entry.d_date_disposed);
    let last_note_date = null;
    if (this.bound_book_entry.notes.length > 0) {
      last_note_date = this.bound_book_entry.notes.reduce((max, note) => {
        const noteDate = new Date(note.dateTime);
        return noteDate > max ? noteDate : max;
      }, new Date(this.bound_book_entry.notes[0].dateTime));
    }
    const mostRecentDate = new Date(
      Math.max(
        acquisition_date.getTime(),
        disposition_date.getTime(),
        last_note_date ? last_note_date.getTime() : 0,
      ),
    );
    return format(mostRecentDate, DateFormats.M_D_Y_H_M_AM);
  }
  createNoteTable() {
    this.noteData = [];
    for (const note of this.bound_book_entry.notes) {
      this.noteData.push(note);
    }
    this.noteData = [...this.noteData];
  }
  createEventTable() {
    this.eventData = [];
    for (const event of this.bound_book_entry.event_log) {
      event.value_changed_from = formatEventValue(event.value_changed_from);
      event.value_changed_to = formatEventValue(event.value_changed_to);
      this.eventData.push(event);
    }
    this.eventData = [...this.eventData];
  }

  closeModalClick(): void {
    this.add_edit_firearm_form.reset();
    this.selected_row = new Firearm();
    this.modalService.hide(ModalID.firearm_info_dash);
  }
  addEditFirearmClick() {
    let return_data: AddEditFirearmResponse = new AddEditFirearmResponse();
    return_data.form_values = this.add_edit_firearm_form.value;
    this.sharedService.firearm_to_add$.next(return_data);
    this.closeModalClick();
  }
  test() {
    this.add_edit_firearm_form.patchValue({
      firearm_upc: '810021510545',
      firearm_type: 'PISTOL',
      manufacture: 'Barrett',
      importer: 'N/A',
      model: 'MRAD',
      additional_markings: 'N/A',
      caliber_gauge: '300 Win Mag',
    });
  }
  editFirearmClick() {
    this.sharedService.openEditBoundBookFirearm(this.bound_book_entry);
  }
  editAcquisitionClick() {
    this.sharedService.openEditBoundBookAcquisition(this.bound_book_entry);
  }
  editDispositionClick() {
    this.sharedService.openEditBoundBookDisposition(this.bound_book_entry);
  }
  expanded(): void {
    this.message = 'expanded';
  }
  disposeFirearm() {
    this.sharedService.closeModal(ModalID.firearm_info_dash);
    this.sharedService.changeRoute('disposition');
    setTimeout(() => {
      this.sharedService.firearm_selected$.next(this.bound_book_entry);
    }, 500);
  }
  async view4473() {
    try {
      console.warn(this.bound_book_entry);
      const form4473 = await this.sharedService.getForm4473ByTransactionSerial(
        this.bound_book_entry.d_form4473_id,
      );
      if (form4473) {
        await this.sharedService.generateAndDisplay4473(form4473);
      } else {
        this.sharedService.raiseErrorToast('Could not find Form 4473 data for this disposition.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  async revertDisposition() {
    // create entry for disposition history
    // update bound book entry
    this.bound_book_entry.d_form4473_id = null;
    this.bound_book_entry.d_first_name = null;
    this.bound_book_entry.d_middle_name = null;
    this.bound_book_entry.d_last_name = null;
    this.bound_book_entry.d_sr_name = null;
    this.bound_book_entry.d_address = null;
    this.bound_book_entry.d_address2 = null;
    this.bound_book_entry.d_zip_code = null;
    this.bound_book_entry.d_city = null;
    this.bound_book_entry.d_state = null;
    this.bound_book_entry.d_date_disposed = null;
    this.sharedService.updateBoundBookEntry(this.bound_book_entry);
  }
  revertDispositionClick() {
    this.sharedService.openYesNoModal(Questions.revert_disposition);
  }
}
